import { Input } from '@chikara/ui';
import {
  ALIAS_TAG_MAX_LENGTH,
  clampMetadataName,
} from '@/features/card/constants/cardMetadata.constants';
import styles from '@/features/card/pages/CardDetailPage/CardDetailPage.module.css';

interface MetadataNameInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
}

export const MetadataNameInput = ({
  label,
  value,
  onChange,
  autoFocus = false,
}: MetadataNameInputProps) => {
  const length = value.length;
  const isAtLimit = length >= ALIAS_TAG_MAX_LENGTH;

  return (
    <div className={styles.metadataInputWrapper}>
      <Input
        label={label}
        value={value}
        maxLength={ALIAS_TAG_MAX_LENGTH}
        onChange={(e) => onChange(clampMetadataName(e.target.value))}
        size="md"
        autoFocus={autoFocus}
      />
      <span
        className={[
          styles.charCounter,
          isAtLimit ? styles.charCounterLimit : '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-live="polite"
      >
        {length}/{ALIAS_TAG_MAX_LENGTH}
      </span>
    </div>
  );
};
